<mat-card *ngIf="editAccidentData" class="accident-card">
  <form #accidentForm="ngForm">

    <!-- HEADER -->
    <mat-toolbar class="accident-toolbar">
      <span style="width:90%">Crash details</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="desar()" matTooltip="Desar" [disabled]="!accidentForm.form.valid">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- CONTINGUT -->
    <div class="accident-content">

      <!-- FORMULARI -->
<div class="accident-form">

  <!-- ==================== BASIC INFORMATION ==================== -->

  <div class="section-title">
    Basic information
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Accident ID</mat-label>
    <input
      matInput
      name="id"
      [(ngModel)]="editAccidentData.id"
      [matAutocomplete]="autoId"
      required>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Plate</mat-label>
    <input
      matInput
      name="plate"
      [(ngModel)]="editAccidentData.plate"
      [matAutocomplete]="autoPlate"
      required>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Date</mat-label>
    <input matInput type="date"
           name="date"
           [(ngModel)]="editAccidentData.date">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Time</mat-label>
    <input matInput type="time"
           name="time"
           [(ngModel)]="editAccidentData.time">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Location</mat-label>
    <input matInput
           name="location"
           [(ngModel)]="editAccidentData.location">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Parish</mat-label>
    <input matInput
           name="parish"
           [(ngModel)]="editAccidentData.parish">
  </mat-form-field>

  <!-- AUTOCOMPLETE -->

  <mat-autocomplete #autoId="matAutocomplete">
    <mat-option *ngFor="let id of idList" [value]="id.value">
      {{ id.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-autocomplete #autoPlate="matAutocomplete">
    <mat-option *ngFor="let plate of plateList" [value]="plate.value">
      {{ plate.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-autocomplete #autoCause="matAutocomplete">
    <mat-option *ngFor="let cause of causeList" [value]="cause.value">
      {{ cause.text }}
    </mat-option>
  </mat-autocomplete>

  <!-- ==================== PEOPLE & VEHICLES ==================== -->

  <div class="section-title">
    People and vehicles involved
  </div>

 <mat-form-field appearance="outline" class="full-width">
  <mat-label>Involved plates</mat-label>

  <mat-chip-list #chipList aria-label="Plate selection">
    <mat-chip *ngFor="let plate of involvedPlates" (removed)="removePlate(plate)">
      {{ plate }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>

    <input
      #plateInput
      [(ngModel)]="plateInputValue"
      name="plateInputValue"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (input)="onPlateInputChange(plateInputValue)"
      (matChipInputTokenEnd)="addPlate($event)">
  </mat-chip-list>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedPlate($event)">
    <mat-option *ngFor="let plate of filteredPlates" [value]="plate">
      {{ plate }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Pedestrians involved</mat-label>
    <input matInput type="number"
           name="number_of_pedestrians"
           [(ngModel)]="editAccidentData.number_of_pedestrians">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Cyclists involved</mat-label>
    <input matInput type="number"
           name="number_of_cyclists"
           [(ngModel)]="editAccidentData.number_of_cyclists">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Number of people injured</mat-label>
    <input matInput type="number"
           name="number_of_injuries"
           [(ngModel)]="editAccidentData.number_of_injuries">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Number of fatalities</mat-label>
    <input matInput type="number"
           name="number_of_fatalities"
           [(ngModel)]="editAccidentData.number_of_fatalities">
  </mat-form-field>

  <!-- ==================== ADDITIONAL INFORMATION ==================== -->

  <div class="section-title">
    Additional information
  </div>

  <mat-form-field appearance="outline" class="half-width">
    <mat-label>Main cause</mat-label>
    <input matInput
           name="main_cause"
           [(ngModel)]="editAccidentData.main_cause"
           [matAutocomplete]="autoCause">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Latitude</mat-label>
    <input matInput
           name="lat"
           [(ngModel)]="editAccidentData.lat">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Longitude</mat-label>
    <input matInput
           name="long"
           [(ngModel)]="editAccidentData.long">
  </mat-form-field>

  </div>

  <!-- MAP VIEW -->
  <div class="accident-preview">
     <div id="map" class="map-frame"></div>
  </div>
</div>

  </form>
</mat-card>